module.exports = __webpack_public_path__ + "img/2tu3pma5HRsX4f41PeBqCa.8aa995ce.svg";